import { METHOD_TYPES } from 'utils/constants/index'
import axiosInstanceService from 'network/apis/index'
import { microServices } from 'network/apis/microservice/index'

export const placeBetRouletteGameService = ({ ...data }) => {
  return axiosInstanceService(METHOD_TYPES.post, '/fast-games/roulette-game/place-bet', data, {
    server: microServices.USER_URL
  })
}

export const getMyBetsRouletteService = (params) => {
  return axiosInstanceService(METHOD_TYPES.get, '/fast-games/roulette-game/my-bets', {}, {
    params,
    server: microServices.USER_URL
  })
}
